module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAhCAYAAADDAmudAAAACXBIWXMAABCcAAAQnAEmzTo0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC4SURBVHgB7dHbDcIwDIVh22UARugKjNAR2IhuApN0lTBIEhxEqgoFemrgBdkvlXL5P7VlAqfXEZGJmSnGOAQd5B4jhxbx/rEUUGQVaMRpC8LGOIzwB3EIETBeLp8XRy4551CPd103lTsQ8OqHavBaz5R4SmlAEEHirdcvawgilvgWRKxxFLkD1vgaMgMa31vjbxCaAY0edGO0xhvIqF/lWNZ2dUMfJ/rCPLeEfjwOOOCAAw448B/ADYQwz/qErlmsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/website/top.png
// module id = 296
// module chunks = 0 1 2